module.exports = __webpack_public_path__ + "static/media/top-img_11@2x.9077235e.jpg";